/**
 * Generate a unique ID with a given prefix.
 *
 * Format: {prefix}_{timestamp}_{random9chars}
 * Example: trip_1706900000000_a1b2c3d4e
 *
 * @param {string} prefix - ID prefix (e.g., 'trip', 'act', 'feedback', 'device')
 * @returns {string} Unique ID string
 */
export default function generateId(prefix) {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}
